<template>
  <div class="container" ref="container">
    <!-- <h1>为您轻松搭建企业掌上大学</h1> -->
    <h1>网班远程考试系统</h1>
    <p class="subtext">
      智能监考&nbsp;&nbsp;&nbsp;&nbsp;AI面部识别&nbsp;&nbsp;&nbsp;&nbsp;多种题型
      &nbsp;&nbsp;&nbsp;&nbsp;题库导入&nbsp;&nbsp;&nbsp;&nbsp;自动阅卷
    </p>
    <el-form
      label-position="top"
      :model="ruleForm"
      status-icon
      :rules="rules"
      label-width="100px"
      class="loginForm"
    >
      <h2>管理员后台登录</h2>
      <el-form-item prop="user">
        <el-input
          type="text"
          placeholder="请输入账号"
          prefix-icon="el-icon-user"
          v-model="ruleForm.user"
          autocomplete="off"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input
          type="password"
          placeholder="请输入登录密码"
          prefix-icon="el-icon-lock"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="submit" @click="submitForm">登录</el-button>
      </el-form-item>
    </el-form>
    <div class="footer">
      <p>上海网班教育科技股份有限公司</p>
      <p>Copyright© Netban.com Allrights Reserved</p>
    </div>
    <el-dialog title="选择机构" :visible.sync="choseOrg" width="30%" center>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'login',

  mounted() {
    let that = this
    this.clientHeight = document.documentElement.clientHeight
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号！'))
      }
      setTimeout(() => {
        if (value.length < 6) {
          callback(new Error('请输入正确格式的账号'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      ruleForm: {
        checkPass: '',
        user: '',
      },
      rules: {
        checkPass: [{ validator: validatePass, trigger: 'blur' }],
        user: [{ validator: validateUser, trigger: 'blur' }],
      },
      clientHeight: 0,
      choseOrg: false,
      org: [],
    }
  },
  watch: {
    clientHeight: function() {
      //this.$refs.container.style.height=this.clientHeight+'px';
      this.changeHeight(this.clientHeight)
    },
  },
  methods: {
    submitForm() {
      let _this = this
      let url = window.location.host
      //      _this.setCookie("loginid",'eyJ0eXAiOiJqd3QiLCJhbGciOiJIUzI1NiJ9.IjEi.CvcIv0Uq4D4RED7cyYGVCSoWnLGpA8_fFTddsQZ_cjk');

      //  _this.Storage.setStorage('orgNumber',this.org[0].number);   //存储所选机构的number
      //        _this.Storage.setStorage('orgs',this.org);              //存储所有机构
      //       window.location.href="/Admin/paperList";

      _this.$http
        .post(process.env.VUE_APP_URL + 'login', _this.ruleForm)
        .then(function(data) {
          if (data.data.code == 403) {
            _this.$message.error(data.data.msg)
            return
          }
          if (data.data.code == 200) {
            let org = data.data.org
            _this.setCookie('loginid', data.data.data)
            if (org.length > 0) {
              _this.Storage.setStorage('orgNumber', org[0].number) //存储所选机构的number
              _this.setCookie('jid', org[0].number)
              _this.Storage.setStorage('orgs', org) //存储所有机构
              window.location.href = '/Admin/paperList'
            }
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          console.log(error)
          _this.$message.error('网络错误,请刷新界面重试')
          return
        })
    },
    changeHeight() {
      this.$refs.container.style.height = this.clientHeight + 'px'
    },
  },
}
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.container h1 {
  text-align: center;
  color: #f0f0f0;
  font-family: 'FZLTZHK--GBK1-0';
  font-size: 36px;
  letter-spacing: 2px;
  margin: 0;
  padding: 60px 0 20px 0;
}
.subtext {
  font-family: 'Adobe Heiti Std R';
  text-align: center;
  font-size: 18px;
  color: #f0f0f0;
  padding-bottom: 40px;
}

.loginForm {
  border-radius: 10px;
  width: 400px;
  margin: 20px auto;
  background: #fff;
  text-align: center;
}
.loginForm h2 {
  text-align: center;
  height: 60px;
  line-height: 60px;
  background-color: #f2f6f9;
  color: #29b084;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-bottom: 20px;
}
.el-form-item {
  padding: 0 20px;
}
.submit {
  width: 100%;
  background-color: #58c68e;
  color: #fff;
  margin-bottom: 20px;
}
.footer {
  width: 100%;
  padding: 10px 0;
  background: #333333;
  color: #ffffff;
  font-family: 'MicrosoftYaHei';
  font-size: 12px;
  position: fixed;
  bottom: 0;
  text-align: center;
}
.footer p {
  height: 16px;
  line-height: 16px;
}
.org {
  text-align: center;
  padding: 5px;
  cursor: pointer;
}
.org:hover {
  background: #cccccc;
}
</style>
